(function () {
  function pushEvent(eventName, properties) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, properties || {}));
  }

  function initializeLanding(root) {
    if (!root || root.dataset.franchiseInitialized === 'true') {
      return;
    }

    root.dataset.franchiseInitialized = 'true';

    root.querySelectorAll('a[href="#contacto"]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        var target = root.querySelector('#contacto');

        pushEvent('franchise_cta_click', {
          label: String(link.textContent || '').replace(/\s+/g, ' ').trim(),
          source: 'franchise-landing'
        });

        if (!target) {
          return;
        }

        event.preventDefault();
        target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
          block: 'start'
        });
      });
    });

    var whatsappLink = root.querySelector('.franchise-whatsapp-float');

    if (whatsappLink) {
      whatsappLink.addEventListener('click', function () {
        pushEvent('franchise_whatsapp_click', { source: 'franchise-landing' });
      });
    }

    var form = root.querySelector('.franchise-form');

    if (form) {
      var hasStarted = false;

      function trackStart() {
        if (hasStarted) {
          return;
        }

        hasStarted = true;
        pushEvent('franchise_form_start', { source: 'franchise-landing' });
      }

      form.addEventListener('input', trackStart);
      form.addEventListener('change', trackStart);
      form.addEventListener('submit', function () {
        pushEvent('franchise_form_submit', { source: 'franchise-landing' });
      });
    }

    var successMessage = root.querySelector('[data-franchise-form-success]');

    if (successMessage) {
      pushEvent('franchise_lead_submitted', { source: 'franchise-landing' });
      successMessage.focus({ preventScroll: true });
    }
  }

  function initializeAll() {
    document.querySelectorAll('[data-franchise-landing]').forEach(initializeLanding);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeAll);
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', initializeAll);
})();
